import { useState } from 'react';
import type { TabItem } from '../components/Tabs';
import { formatSolutionType } from '../lib/formatters';
import { UNASSIGNED_SOLUTION } from './useTripAssets';

export function solutionTabLabel(type: string): string {
  return type === UNASSIGNED_SOLUTION ? 'No solution type' : formatSolutionType(type);
}

/**
 * Tab state over the solution types that actually have assets. The first
 * present type is selected until the technician picks another; a selection
 * that disappears (data refetch) falls back instead of showing nothing.
 */
export function useSolutionTabs(solutionTypes: string[] | undefined, byType: Record<string, unknown[]> | undefined) {
  const [selected, setSelected] = useState<string | null>(null);
  const types = solutionTypes ?? [];
  const active = selected && types.includes(selected) ? selected : (types[0] ?? null);
  const tabs: TabItem<string>[] = types.map((t) => ({
    key: t,
    label: solutionTabLabel(t),
    count: byType?.[t]?.length,
  }));
  return { active, setActive: setSelected, tabs };
}
